<template>
  <b-container fluid>
    <control-list-bar @searchChange="newSearch => (searchedText = newSearch)" />
    <template v-if="calls.length">
      <b-row v-for="call in filteredCalls" :key="call.id">
        <b-col align-self="center">
          <call-card :call="call" />
        </b-col>
      </b-row>
    </template>
    <b-row v-else>
      <b-col cols="12" align-self="center">
        <p class="text-center font-weight-bold bg-light text-uppercase">
          No hay convocatorias disponibles aún
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import CallCard from '@/components/cards/CallCard'
import names from '@/config/names'
import tagsColors from '@/pages/calls/attendee/tagColors.json'
import { mapActions, mapState } from 'vuex'
import ControlListBar from '@/components/search/ControlListBar'
import { errorOnDataLoad } from '@/services/messageService'

export default {
  name: 'AttendeeCallList',
  components: {
    CallCard,
    ControlListBar,
  },
  data() {
    return {
      sortBy: 'date',
      searchedText: '',
      isLoading: true,
      names,
    }
  },
  computed: {
    ...mapState('notices', { calls: 'callRecipients' }),
    filteredCalls() {
      return this.calls
        .filter(call => {
          for (const property of Object.values(call)) {
            if (
              typeof property === 'string' &&
              property.toLowerCase().includes(this.searchedText.toLowerCase())
            ) {
              return true
            }
          }
        })
        .sort((a, b) => new Date(b.date) - new Date(a.date))
    },
  },
  watch: {
    filteredCalls: {
      handler: function () {},
      deep: true,
    },
    calls: {
      handler: function () {},
      deep: true,
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    ...mapActions('notices', ['fetchNoticeRecipients']),
    retrieveTableRowClassName({ row }) {
      if (row.status === 'pending') {
        return 'warning-row'
      }
      return ''
    },
    selectStatusColor(status) {
      return tagsColors[status]
    },
    async loadData() {
      try {
        await this.fetchNoticeRecipients('call')
        this.isLoading = false
      } catch (error) {
        errorOnDataLoad({ context: this, error })
      }
    },
  },
}
</script>

<style scoped></style>
